module.exports = __webpack_public_path__ + "img/e_2_5_g.499aac5a.png";